import Lenis from 'lenis'
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
// import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin';
import { MotionPathPlugin } from 'gsap/dist/MotionPathPlugin';

gsap.registerPlugin(
  ScrollTrigger,
  // ScrollToPlugin,
  MotionPathPlugin,
);

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.MotionPathPlugin = MotionPathPlugin;
window.Lenis = Lenis;

const lenis = new Lenis({
  duration: 1.2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
});

function raf(time) {
  lenis.raf(time);
  ScrollTrigger.update();
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

$(document).ready(function () {
  function setAni(className, animation) {
    gsap.utils.toArray("." + className).forEach((el) => {
      let config = {
        opacity: 0,
        duration: 0.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: el,          // ✅ 每個元素自己當 trigger
          start: "top 85%",
          toggleActions: "play none none none"
        }
      };

      // 根據動畫種類設定
      if (animation === "fade-up") {
        config.y = 50;
      } else if (animation === "zoom-in") {
        config.scale = 0.8;
      }

      gsap.from(el, config);
    });
  }

  // 呼叫不同效果
  setAni("ani-fade-up", "fade-up");
  setAni("ani-fade-in", "fade-in");
  setAni("ani-zoom-in", "zoom-in");

  if ($('.wrap').data('page') == 'home') {
    let mm = gsap.matchMedia();

    // 城市大動脈
    function createSmartMobilityAnimation(config) {
      let smart_mobility_tl = gsap.timeline({
        scrollTrigger: {
          trigger: "[data-home=smart_mobility]",
          start: config.start,
          end: config.end,
          scrub: config.scrub,
          // markers: true,
        }
      });

      smart_mobility_tl
        .to(".bg-city-left, .bg-city-right", { yPercent: 10 , duration: 0.5}, )
        .to(".index-main-vision-city, .index-main-vision-title", { yPercent: -6 }, '<')
        .from(".traffic_signal_1", { opacity: 0 })
        .from(".car_1", { xPercent: 140, yPercent: -200, scale: 0, duration: 1})
        .from(".car_2", { xPercent: 45, yPercent: -200, scale: 0, duration: 1 }, '>-=0.85')
        .from(".car_3", { xPercent: 220, yPercent: -180, scale: 0 , duration: 1}, '<')
        .from(".car_4", { xPercent: 110, yPercent: -110, scale: 0, duration: 1 }, '>-=0.95')
        .from(".car_5", { xPercent: 380, yPercent: -150, scale: 0 , duration: 1}, '>-=0.9')
        .from(".car_6", { xPercent: 45, yPercent: -150, scale: 0 , duration: 1}, '>-=0.8')
        .from(".car_7", { xPercent: 160, yPercent: -80, scale: 0 , duration: 1}, '>-=0.7')
        .to(".traffic_signal_1 .focus-light", { opacity: 1, duration: 0.3}, '>-=1')
        .to(".ab-img-focus .focus-line", { opacity: 1, delay: 0.5 }, '<')
        .from("[ data-home=smart_mobility] .item-content-inner", {opacity: 0, yPercent: 5, duration: 0.5})
        .from("#smart_mobility_img", {opacity: 0 }, '<')
        .from("#smart_mobility_img .actual-img-border", {opacity: 0, scale: 0.9, ease: "elastic.inOut(1,0.5)"}, '<');

      return smart_mobility_tl;
    }

    // 智慧執法
    function createTrafficSafetyAnimation(config) {
      let traffic_safety_tl = gsap.timeline({
        scrollTrigger: {
          trigger: "[data-home=traffic_safety]",
          start: config.start,
          end: config.end,
          scrub: config.scrub,
          // markers: true,
        }
      });
      traffic_safety_tl
        .from(".car_blue", { xPercent: -480, yPercent: -250, duration: 1})
        .from(".car_red", { xPercent: -250, yPercent: 250, duration: 1.2}, '<')
        .to(".car_red .focus-line", { opacity: 1, duration: 0.6}, '>-=0.7')
        .from("[data-home=traffic_safety] .item-content-inner", {opacity: 0, yPercent: 5, duration: 0.5},'<')
        .from(".car_white", { xPercent: 250, yPercent: 200, duration: 0.6}, '<-=0.5')
        .from("[data-home=traffic_safety] .alert_mark", { opacity: 0, scale: 0, ease: "back.out(2)"})
        .from("#traffic_safety_img", {opacity: 0 , duration: 0.3}, '>-=0.2')
        .from("#traffic_safety_img .actual-img-border", {opacity: 0, scale: 0.9, ease: "elastic.inOut(1,0.5)"}, '<');

      return traffic_safety_tl;
    }

    // 停車
    function createSmartParkingAnimation(config) {
      let smart_parking_tl = gsap.timeline({
        scrollTrigger: {
          trigger: "[data-home=smart_parking]",
          start: config.start,
          end: config.end,
          scrub: config.scrub,
          // markers: true,
        }
      });
      smart_parking_tl
        .from(".car_in", { xPercent: -300, yPercent: -300, duration: 1})
        .to(".car_in .focus", { opacity: 1, scale: 1.1, ease: "back.out(2)"})
        .from("#smart_parking_img_1", {opacity: 0 , duration: 0.3})
        .from("#smart_parking_img_1 .actual-img-border", {opacity: 0, scale: 0.9, ease: "elastic.inOut(1,0.5)"}, '<')
        .from(".car_out", { xPercent: 100, yPercent: 100, duration: 0.6}, '<-=0.5')
        .from(".car_out .bill", { yPercent: 50, opacity: 0, ease: "back.out(2)"})
        .from("[data-home=smart_parking] .item-content-inner", {opacity: 0, yPercent: 5, duration: 0.5}, '<')
        .from(".car_out .check_success", {scale: 0, opacity: 0, ease: "back.out(2)"})
        .to(".parking_gate", {rotate: -60, yPercent: 15})
        .from("#smart_parking_img_2", {opacity: 0 , duration: 0.3}, '<')
        .from("#smart_parking_img_2 .actual-img-border", {opacity: 0, scale: 0.9, ease: "elastic.inOut(1,0.5)"}, '<')
        .to(".car_out", { xPercent: -100, yPercent: -100, duration: 1})

        return smart_parking_tl;
      }

      // 智慧樓宇未來建築新典範
      function createSmartBuildingsAnimation(config) {
        let smart_buildings_tl = gsap.timeline({
          scrollTrigger: {
            trigger: "[data-home=smart_buildings]",
            start: config.start,
            end: config.end,
            scrub: config.scrub,
            onEnter: () => {
              $("#staff").addClass("active");
            },
            onLeaveBack: () => {
              $("#staff").removeClass("active"); // 如果要回滾時拿掉
            }
            // markers: true,
          }
        });
        smart_buildings_tl
        .fromTo("#staff",
          { xPercent: 0, yPercent: 0, scale: 0.8 },
          { xPercent: 700,yPercent: 230, scale: 1, duration: 1.7}, '<'
        )
        .set("#staff", {className: "-=staff"})
        .to(".door_left", {xPercent: -70, yPercent: 12, duration: 1}, '>=-0.8')
        .to(".door_right", {xPercent: 70, yPercent: -12, duration: 1}, '<')
        .from(".staff_confirm", {yPercent: 20,  opacity: 0}, '>=-0.5')
        .from(".buildings-focus-line", {opacity: 0})
        .from("[data-home=smart_buildings] .item-content-inner", {opacity: 0, yPercent: 5, duration: 0.5}, '<')
        .from("#smart_buildings_img", {opacity: 0 , duration: 0.3}, '<')
        .from("#smart_buildings_img .actual-img-border", {opacity: 0, scale: 0.9, ease: "elastic.inOut(1,0.5)"}, '<')
        .from(".confirm_line", {yPercent: -50,  opacity: 0, duration: 0.3},)
        .from(".confirm_check", {scale: 0,  opacity: 0, duration: 0.3},)
        .from(".in_out_num", {yPercent: 20,  opacity: 0}, )
        .to(".gate_left", { skewY: 32, ease: "back.out(2)", duration: 0.3})
        .to(".gate_right", { scaleX: 0.3, ease: "back.out(2)", duration: 0.3}, '<')

      return smart_buildings_tl;
    }

    // 港口智鏈高效物流核心
    function createConnectedPortsAnimation(config) {
      let connected_ports_tl = gsap.timeline({
        scrollTrigger: {
          trigger: "[data-home=connected_ports]",
          start: config.start,
          end: config.end,
          scrub: config.scrub,
          // markers: true,
        }
      });
      connected_ports_tl
        .from(".connected_ports_track", {xPercent: -700, yPercent: -500, duration: 1.5})
        .from("#connected_ports_img_1", {opacity: 0 , duration: 0.3})
        .from("#connected_ports_img_1 .actual-img-border", {opacity: 0, scale: 0.9, ease: "elastic.inOut(1,0.5)"}, '<')
        .from("[data-home=connected_ports] .item-content-inner", {opacity: 0, yPercent: 5, duration: 0.5}, '<')
        .from(".connected_ports_weight", { opacity: 0, duration: 1})
        .from("#connected_ports_img_2", {opacity: 0 , duration: 0.3})
        .from("#connected_ports_img_2 .actual-img-border", {opacity: 0, scale: 0.9, ease: "elastic.inOut(1,0.5)"}, '<')
        .to(".connected_ports_track", {xPercent: 120, yPercent: 70, duration: 0.7})
        .to(".connected_ports_clip", { yPercent: 65, duration: 0.5})

      return connected_ports_tl;
    }

    //全域守護智慧安全防線
    function createSmartSecurityAnimation(config) {
      let smart_security_tl = gsap.timeline({
        scrollTrigger: {
          trigger: "[data-home=smart_security]",
          start: config.start,
          end: config.end,
          scrub: config.scrub,
          //markers: true,
        }
      });
      smart_security_tl
        .from(".alert_mark", {opacity: 0, scale: 0, ease: "elastic.inOut(1,0.5)"})
        .from("[data-home=smart_security] .item-content-inner", {opacity: 0, yPercent: 5, duration: 0.5}, '<')
        .from("#thick_smoke", {opacity: 0 , duration: 0.3})
        .from("#thick_smoke .actual-img-border", {opacity: 0, scale: 0.9, ease: "elastic.inOut(1,0.5)"}, '<')
        .from("#fall", {opacity: 0 , duration: 0.3})
        .from("#fall .actual-img-border", {opacity: 0, scale: 0.9, ease: "elastic.inOut(1,0.5)"}, '<')
        .from("#climb", {opacity: 0 , duration: 0.3})
        .from("#climb .actual-img-border", {opacity: 0, scale: 0.9, ease: "elastic.inOut(1,0.5)"}, '<')

      return smart_security_tl;
    }

    // 桌面版 (≥800px)
    mm.add("(min-width: 800px)", () => {
      const indexMain_tl = gsap.timeline();
      indexMain_tl
        .fromTo("#title_en", { xPercent: -100, opacity: 0}, { xPercent: 0, opacity: 1, ease: "back.inOut(1.7)",duration: 1},)
        .fromTo("#title_main", { xPercent: -100, opacity: 0}, { xPercent: 0, opacity: 1, ease: "back.inOut(1.7)",duration: 1}, '>=-0.5')
        .from(".vision-line-light", { scaleY: 0 ,opacity: 0, ease: "back.out(1.1)", duration: 1}, '>=-0.5')
        .from(".index-main-vision-arrow", { opacity: 0, ease: "back.inOut(1.7)", duration: 0.5 }, '<')
        .from(".vision-bg-light", { opacity: 0, ease: "back.inOut(1.7)", duration: 0.5 });

      createSmartMobilityAnimation({
        start: "-20% center",
        end: "25% center",
        scrub: 0.2
      });

      createTrafficSafetyAnimation({
        start: "top center",
        end: "60% center",
        scrub: 0.2
      });

      createSmartParkingAnimation({
        start: "top bottom",
        end: "80% center",
        scrub: 0.2
      });

      createSmartBuildingsAnimation({
        start: "35% bottom",
        end: "bottom bottom",
        scrub: 0.2
      });

      createConnectedPortsAnimation({
        start: "center bottom",
        end: "110% bottom",
        scrub: 0.2
      });

      createSmartSecurityAnimation({
        start: "center bottom",
        end: "bottom bottom",
        scrub: 0.2
      });

    });

    // 平板直向 (640px-799px, portrait)
    mm.add("(max-width: 799px) and (min-width: 640px) and (orientation: portrait)", () => {
      const indexMain_tl = gsap.timeline();
      indexMain_tl
        .fromTo("#title_en", { yPercent: 20, opacity: 0}, { yPercent: 0, opacity: 1, ease: "back.inOut(1.7)",duration: 1},)
        .fromTo("#title_main", { yPercent: 20, opacity: 0}, { yPercent: 0, opacity: 1, ease: "back.inOut(1.7)",duration: 1}, '>=-0.5')
        .from(".index-main-vision-arrow", { opacity: 0, ease: "back.inOut(1.7)", duration: 0.5 }, '<')
        .from(".vision-line-light", { scaleY: 0 ,opacity: 0, ease: "back.out(1.1)", duration: 1}, '>=-0.5');

      createSmartMobilityAnimation({
        start: "top 90%",
        end: "70% bottom",
        scrub: 1
      });
      createTrafficSafetyAnimation({
        start: "top bottom",
        end: "70% bottom",
        scrub: 0.2
      });
      createSmartParkingAnimation({
        start: "top bottom",
        end: "70% center",
        scrub: 0.2
      });
      createSmartBuildingsAnimation({
        start: "30% bottom",
        end: "center center",
        scrub: 0.2
      });
       createConnectedPortsAnimation({
        start: "top center",
        end: "center center",
        scrub: 0.2
      });
      createSmartSecurityAnimation({
        start: "top center",
        end: "center center",
        scrub: 0.2
      });
    });

    // 手機版 (<640px)
    mm.add("(max-width: 640px)", () => {
      const indexMain_tl = gsap.timeline();
      indexMain_tl
        .fromTo("#title_en", { yPercent: 20, opacity: 0}, { yPercent: 0, opacity: 1, ease: "back.inOut(1.7)",duration: 0.6},)
        .fromTo("#title_main", { yPercent: 20, opacity: 0}, { yPercent: 0, opacity: 1, ease: "back.inOut(1.7)",duration: 1}, '>=-0.5')
        .from(".vision-line-light", { scaleY: 0 ,opacity: 0, ease: "back.out(1.1)", duration: 1}, '>=-0.5')
        .from(".index-main-vision-arrow", { opacity: 0, ease: "back.inOut(1.7)", duration: 0.5 },'<');

      createSmartMobilityAnimation({
        start: "top center",
        end: "70% bottom",
        scrub: 1
      });
      createTrafficSafetyAnimation({
        start: "top 70%",
        end: "center center",
        scrub: 0.2
      });
      createSmartParkingAnimation({
        start: "top 70%",
        end: "center center",
        scrub: 0.2
      });
      createSmartBuildingsAnimation({
        start: "30% bottom",
        end: "center center",
        scrub: 0.2
      });
       createConnectedPortsAnimation({
        start: "30% bottom",
        end: "70% bottom",
        scrub: 0.2
      });

      createSmartSecurityAnimation({
        start: "30% bottom",
        end: "70% bottom",
        scrub: 0.2
      });
    });
  }

});
